var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_104_899",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87695 11C1.87695 5.47778 6.35473 1 11.877 1C17.3992 1 21.877 5.47778 21.877 11C21.877 16.5222 17.3992 21 11.877 21C6.35473 21 1.87695 16.5222 1.87695 11Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43262 11.0001L10.766 14.3334L16.3215 8.77783",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_104_899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2106 -2.3335H-1.45605V24.3332H25.2106V-2.3335Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMsg);
export default __webpack_public_path__ + "static/media/send_msg.67d02ba9beac2b16e952f53f5d968fbb.svg";
export { ForwardRef as ReactComponent };